import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = process.env.REACT_APP_API_BASE_URL;
const STORAGE = process.env.REACT_APP_STORAGE_URL;

interface ProductImage {
  id: number;
  image: string;
}

interface Category {
  id: number;
  name: string;
}

interface Product {
  id: number;
  name: string;
  price: string;
  discount: number | null;
  final_price: string;
  images: ProductImage[];
  category?: Category;
}

export default function ProductGrid() {
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/produk`).then((res) => {
      setProducts(res.data.data);
    });
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 py-14">
      {/* TITLE */}
      <div className="flex items-center justify-center gap-4 mb-12">
        <div className="h-[1px] bg-gray-300 flex-1"></div>
        <h2 className="text-sm md:text-2xl font-bold uppercase tracking-[0.35em] text-gray-700">Looking For This</h2>
        <div className="h-[1px] bg-gray-300 flex-1"></div>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
        {products.map((product) => {
          const image = product.images?.length > 0 ? `${STORAGE}/products/${product.images[0].image}` : "/no-image.png";

          const hasDiscount = product.discount && product.discount > 0;

          return (
            <Link key={product.id} to={`/produk/${product.id}`} className="group">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-gray-200 hover:shadow-xl transition duration-300">
                {/* IMAGE */}
                <div className="relative overflow-hidden aspect-square bg-gray-50">
                  <img src={image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />

                  {hasDiscount && <span className="absolute top-3 right-3 bg-primary text-white text-[11px] font-semibold px-3 py-1 rounded-full shadow">-{product.discount}%</span>}
                </div>

                {/* CONTENT */}
                <div className="p-4 space-y-2">
                  {/* CATEGORY */}
                  {product.category && <p className="text-[11px] uppercase tracking-wide text-gray-400">{product.category.name}</p>}

                  {/* NAME */}
                  <h3 className="text-sm font-semibold text-gray-800 line-clamp-2 leading-snug">{product.name}</h3>

                  {/* PRICE */}
                  <div className="flex items-center gap-2 pt-1">
                    {hasDiscount ? (
                      <>
                        <span className="text-gray-400 line-through text-xs">Rp {Number(product.price).toLocaleString()}</span>

                        <span className="text-primary font-bold text-sm">Rp {Number(product.final_price).toLocaleString()}</span>
                      </>
                    ) : (
                      <span className="text-gray-900 font-bold text-sm">Rp {Number(product.price).toLocaleString()}</span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      {/* BUTTON */}
      <div className="flex justify-center mt-14">
        <Link to="/produk" className="px-8 py-3 rounded-full border border-gray-300 hover:border-primary hover:text-primary transition font-semibold text-sm">
          Lihat Semua Produk
        </Link>
      </div>
    </section>
  );
}
